import React, { useEffect, useState } from 'react'
import Banner from "./components/Banner/Index";
import Overview from './components/Aboutus/Overview';
import './components/Aboutus/index.css'
import BusinessEnquiry from "./components/Forms/Enquiry";
import axios from 'axios';
import { API_BASE_URL } from "./Utils/useApi";
import { CircularProgress } from "@mui/material";
import ProListing from './components/Products/ProListing';

const Services = () => {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/what_we_do.php`);
        setPageData(response.data);
      }
      catch (err) {
        setError(err.message);
      }
      finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);
  if (loading) return (
    <div className="preloader flex-center">
      <CircularProgress size={24} />
    </div>
  );
  if (error) return (
    <div>Error: An error occurred while fetching data</div>
  )
  const { homeBanner, Highlights, what_we_do_content, what_we_do } =
    pageData;

  return (
    <main>
      <Banner Data={homeBanner} />
      {what_we_do_content && <Overview Data={what_we_do_content} Data2={Highlights} _class={'text-lg-center text-start'}/>}
      <ProListing Data={what_we_do} servicePage={true} listingClass={'servicePage titlePosition'} />
      <BusinessEnquiry />
    </main>
  )
}

export default Services